export const environment = {
    production: false,
    apiUrl: 'https://demo.cat-risk.com/api',
    gmap_key: 'AIzaSyDhnCkyEXNaRnHmm90R-pUGlAWtK7WnIZo',
    baseUrl: 'https://demo.cat-risk.com',
    captcha_siteKey: '6LfZW_srAAAAACWG6dJsgos-954mPZokNfJu_aX9',
    frontendUrl: 'https://demo-yokahu-frontend.yokahu.co',
    chatbotApiUrl: 'https://demo.cat-risk.com/chat-api'
};
	
